<template>
  <div class="search-container">
    <h1>寻找最适合你的导师</h1>
    <div class="search-type-toggle">
      <button
        :class="{ active: searchType === 'professor' }"
        @click="searchType = 'professor'">
        搜导师
      </button>
<!--      <button-->
<!--        :class="{ active: searchType === 'school' }"-->
<!--        @click="searchType = 'school'">-->
<!--        搜学校-->
<!--      </button>-->
    </div>
    <div class="search-box">
      <input
          v-model="searchQuery"
          type="text"
          :placeholder="searchType === 'professor' ? '输入导师姓名...' : '输入学校名称...'"
          @keyup.enter="handleSearch"
      />
      <button @click="handleSearch">
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16">
          <path d="M11.742 10.344a6.5 6.5 0 1 0-1.397 1.398h-.001c.03.04.062.078.098.115l3.85 3.85a1 1 0 0 0 1.415-1.414l-3.85-3.85a1.007 1.007 0 0 0-.115-.1zM12 6.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0z"/>
        </svg>
        搜索
      </button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      searchType: 'professor', // 新增搜索类型状态
      searchQuery: '',
      selectedUniversity: '',
      selectedDepartment: '',
    }
  },
  methods: {
    handleSearch() {
      console.log('Search type:', this.searchType, 'Query:', this.searchQuery) // 调试用
      if (this.searchType === 'professor') {
        this.$router.push({
          name: 'ProfessorSearchResults',
          query: { q: this.searchQuery }
        })
      } else {
        // 确保这里使用了正确的路由名称和参数
        this.$router.push({
          name: 'SchoolSearchResults',  // 必须与路由配置中的name一致
          query: { q: this.searchQuery }  // 参数名必须与SchoolSearchResults组件中读取的一致
        })
      }
    }
  }
}
</script>

<style scoped>
/* 新增样式 */
.search-type-toggle {
  display: flex;
  justify-content: center;
  margin-bottom: 1rem;
  gap: 10px;
}

.search-type-toggle button {
  padding: 0.5rem 1rem;
  background-color: #e9ecef;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  transition: all 0.3s;
}

.search-type-toggle button.active {
  background-color: #3498db;
  color: white;
}

.search-container {
  text-align: center;
  padding: 3rem 1rem;
  background-color: #f8f9fa;
  border-radius: 8px;
  margin: 2rem auto;
  max-width: 800px;
}

h1 {
  color: #2c3e50;
  margin-bottom: 1.5rem;
}

.search-box {
  display: flex;
  margin-bottom: 1rem;
}

.search-box input {
  flex: 1;
  padding: 0.75rem 1rem;
  border: 1px solid #ddd;
  border-radius: 4px 0 0 4px;
  font-size: 1rem;
}

.search-box button {
  padding: 0 1.5rem;
  background-color: #3498db;
  color: white;
  border: none;
  border-radius: 0 4px 4px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.search-box button:hover {
  background-color: #2980b9;
}

.filters {
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.filters select {
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  background-color: white;
}
</style>

